import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';
import OtpInput from 'react-otp-input';
import Lottie from 'lottie-react';

// import { ReactComponent as TickIcon } from '../../../../public';

import HeaderComponent from '../../LandingPage/Components/Header';
import InputComponent from '../../../components/Input';
import useStoreData from '../Hooks/useStoreData';

import sparkleAnimation from '../../../lotties/Sparkel.json';
import storeAnimation from '../../../lotties/store.json';
import loaderAnimation from '../../../lotties/Loader2.json';
import ConfirmationModal from './confirmationModal';
import SelfRegisterForm from './selfRegisterForm';
import { useHistory } from 'react-router-dom';

const StoreCreationComponent = (props) => {
  const history = useHistory();
  const {
    selectCategory,
    category,
    selectSubCategory,
    subCategory,
    categoryData,
    selectedSubCatagories,
    onContinueClick,
    businessDetailsShown,
    onChangeBusinessDetails,
    businessDetails,
    getCategoriesData,
    storeCreated,
    onSelfRegisterClick,
    onRequestCallback,
    callbackLoading,
    toggleSelfRegisterForm,
    selfRegisterForm,
    selfRegisterDetails,
    onSelfRegisterSubmit,
    onChangeSelfRegister,
    handleImage,
    removeImage,
    media,
  } = useStoreData();

  useEffect(() => {
    getCategoriesData();
  }, []);

  useEffect(() => {
    onChangeBusinessDetails({ target: { name: 'mobileNumber', value: props.mobileNumber } });
  }, [props]);

  return (
    <div className={`pb-1`}>
      <HeaderComponent />
      {storeCreated ? (
        <div className={`${styles.animationContainer}`}>
          <Lottie
            className={`${styles.sparkleAnimation}`}
            animationData={sparkleAnimation}
            loop={true}
          />
          <Lottie
            className={`${styles.houseAnimation}`}
            animationData={storeAnimation}
            loop={true}
          />
          <h1 className={`${styles.simpleBlueText} ${styles.congratsText}`}>Congratulations!</h1>
          <h1 className={`${styles.smallSemibold} mt-4`}>Welcome to Falcon!</h1>
          <h1 className={`${styles.smallSemibold}`}>It’s time to add your first product now!</h1>
          <button
            onClick={() => {
              history.push('/signin');
            }}
            className={`mt-3 ${styles.continueButton}`}
          >
            <span>Continue with Login</span>
          </button>
        </div>
      ) : selfRegisterForm ? (
        <SelfRegisterForm
          selfRegisterDetails={selfRegisterDetails}
          onSubmit={onSelfRegisterSubmit}
          onChangeSelfRegister={onChangeSelfRegister}
          handleImage={handleImage}
          removeImage={removeImage}
          media={media}
          callbackLoading={callbackLoading}
        />
      ) : !businessDetailsShown ? (
        <div className={`${styles.storeCreationContainer}`}>
          <h2 className={styles.smallSemibold}>What kind of store do you have?</h2>

          <div className={`${styles.categoryContainer}`}>
            {categoryData.map((cat) => {
              return (
                <button
                  className={`${category === cat.key ? styles.selectedCatBox : styles.catBox}`}
                  onClick={() => {
                    selectCategory(cat.key);
                  }}
                >
                  {category === cat.key && <img src="/images/Checkbox.svg" />}
                  {cat.name}
                </button>
              );
            })}
          </div>

          {!!(selectedSubCatagories || []).length && (
            <h2 className={`mt-3 ${styles.smallSemibold}`}>Products you sell?</h2>
          )}

          {!!(selectedSubCatagories || []).length && (
            <div className={`${styles.categoryContainer}`}>
              {(selectedSubCatagories || []).map((subCat) => {
                return (
                  <button
                    className={`${
                      subCategory.includes(subCat.key) ? styles.selectedCatBox : styles.catBox
                    }`}
                    onClick={() => {
                      selectSubCategory(subCat.key);
                    }}
                  >
                    {subCategory.includes(subCat.key) && <img src="/images/Checkbox.svg" />}
                    {subCat.name}
                  </button>
                );
              })}
            </div>
          )}

          <button
            disabled={category || subCategory.length ? false : true}
            onClick={onContinueClick}
            className={`mt-4 ${
              category || subCategory.length ? styles.enabledSubmit : styles.disabledSubmit
            }`}
          >
            <span>Continue</span>
          </button>
        </div>
      ) : (
        <div className={`${styles.businessDetailsContainer}`}>
          <h2 className={styles.smallSemibold}>Enter you Business Details</h2>

          <div className={`mt-3 ${styles.businessInputContainer}`}>
            {businessDetails.ownerName && <span>Business Name</span>}
            <InputComponent
              disabled={callbackLoading ? true : false}
              className={`${styles.businessInputBox} bg-white`}
              value={businessDetails.ownerName}
              placeholder={'Business Name'}
              name={'ownerName'}
              handleChange={onChangeBusinessDetails}
            />
          </div>

          <div className={`mt-3 ${styles.businessInputContainer}`}>
            {businessDetails.mobileNumber && <span>Phone No</span>}
            <InputComponent
              disabled={callbackLoading ? true : false}
              className={`${styles.businessInputBox} bg-white`}
              type={'number'}
              value={businessDetails.mobileNumber}
              placeholder={'Phone No'}
              name={'mobileNumber'}
              handleChange={onChangeBusinessDetails}
            />
          </div>
          <div className={`mt-3 ${styles.businessInputContainer}`}>
            {businessDetails.city && <span>City</span>}
            <InputComponent
              disabled={callbackLoading ? true : false}
              className={`${styles.businessInputBox} bg-white`}
              value={businessDetails.city}
              placeholder={'City'}
              name={'city'}
              handleChange={onChangeBusinessDetails}
            />
          </div>

          <button
            disabled={
              businessDetails.city &&
              (businessDetails.mobileNumber ? businessDetails.mobileNumber.length === 10 : false) &&
              businessDetails.ownerName &&
              !callbackLoading
                ? false
                : true
            }
            onClick={toggleSelfRegisterForm}
            className={`mt-4 ${
              businessDetails.city &&
              (businessDetails.mobileNumber ? businessDetails.mobileNumber.length === 10 : false) &&
              businessDetails.ownerName &&
              !callbackLoading
                ? styles.enabledSubmit
                : styles.disabledSubmit
            }`}
          >
            <span>Self Register</span>
          </button>

          {businessDetails.city &&
            (businessDetails.mobileNumber ? businessDetails.mobileNumber.length === 10 : false) &&
            businessDetails.ownerName && (
              <button
                disabled={callbackLoading ? true : false}
                className={`mt-4 bg-white border-0 ${
                  callbackLoading ? styles.simpleBlueText : styles.blueText
                }`}
                onClick={onRequestCallback}
              >
                <span>Request Callback</span>
              </button>
            )}

          {callbackLoading && (
            <Lottie
              className={`${styles.loaderAnimation} mt-3`}
              animationData={loaderAnimation}
              loop={true}
            />
          )}
          <ConfirmationModal />
        </div>
      )}
    </div>
  );
};
export default StoreCreationComponent;
